/*
	File handles all API request for StateRules
*/
import { server } from '../engine/server'
import { modal } from '../../core/utilities/modal'

var BuildingLevelsState = Class.create({
  	initialize: function() {
        // #  Prepare our server object for data use
  		this.server = server;
	},
	getBuildingLevelStateRules: function(context) {
		// #  Localize this instance for use on success
		var self = this;

		var url = "staterules/building/level";
		// #  Send to server object for processing
		var data = this.server.getData(url,null,false);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{

			}
            
            context.setState({
                stateListeners: response.data
            });
		})
		.fail(function(e){
			console.log(e);
		});
    },
    /**
	*
	* Adds new buiilding level listener
	*
	*/
	addBuildingLevelListener: function(context) {
		var self = this;
		// prepare our data to be sent
		var url = "staterules/building/level/new";
		var params = context.state;
		var data = this.server.getData(url,params,false, "POST");
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
                modal.showInfo("New state has been added!", "success", "top", "center");
                context.setState({
                    reload: true
                });
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
    },
    /**
     * Removes levels building state based on passed levels state id
     */
    removeLevelsState: function(id, context) {
        var self = this;
		// prepare our data to be sent
		var url = "staterules/building/level/" + id;
		var data = this.server.getData(url,null,false, "DELETE");
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1) {
			}
			else if(response.data.error || (response.status == 1 || response.status == 2)) {
            }
            else {
                modal.showInfo("Level State Listener has been removed!", "success", "top", "center");
                context.setState({
                    reload: true
                });
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
    }
});

export let buildingLevelsState = new BuildingLevelsState();


// WEBPACK FOOTER //
// app/core/controllers/BuildingLevelsState.js